import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { IncrementFor } from 'frontend-utils';

interface MarketCustomReportingSidebarLoadingStateSignature {
  Args: {
    canEdit?: boolean;
    foldersOnly?: boolean;
  };
}

const MarketCustomReportingSidebarLoadingState = <template>
  {{#if @foldersOnly}}
    <div class="sidebar-category pt-200 pr-400 pb-200 pl-200">
      <IncrementFor @times={{3}}>
        <div class="sidebar-item main-folder pr-100 pl-200">
          <button
            class="button--unstyled folder-button flex w-full flex-row items-center gap-200"
            disabled
            type="button"
          >
            <PrismIcon
              @color="inherit"
              @name="chevron-right"
              @size="small"
              class="chevron"
            />
            <div class="loading-pulse loading-pulse--col-6"></div>
          </button>
        </div>
      </IncrementFor>
    </div>
  {{else}}
    {{#if @canEdit}}
      <div class="sidebar-category pt-200 pr-400 pb-200 pl-200">
        <div class="sidebar-item main-folder pr-100 pl-200">
          <button
            class="button--unstyled folder-button flex w-full flex-row items-center gap-200"
            disabled
            type="button"
          >
            <PrismIcon
              @color="inherit"
              @name="chevron-right"
              @size="small"
              class="chevron"
            />
            <span class="truncate">
              {{t "custom_reporting.my_dashboards"}}
            </span>
          </button>
        </div>
      </div>
    {{/if}}
    <div class="sidebar-category pt-200 pr-400 pb-200 pl-200">
      <div class="sidebar-item main-folder pr-100 pl-200">
        <button
          class="button--unstyled folder-button flex w-full flex-row items-center gap-200"
          disabled
          type="button"
        >
          <PrismIcon
            @color="inherit"
            @name="chevron-right"
            @size="small"
            class="chevron"
          />
          <div class="loading-pulse loading-pulse--col-6"></div>
        </button>
      </div>
    </div>
    <div class="sidebar-category pt-200 pr-400 pb-200 pl-200">
      <div class="sidebar-item main-folder pr-100 pl-200">
        <button
          class="button--unstyled folder-button flex w-full flex-row items-center gap-200"
          disabled
          type="button"
        >
          <PrismIcon
            @color="inherit"
            @name="templates"
            @size="small"
            class="chevron"
          />
          <span class="truncate">
            {{t "custom_reporting.made_for_you"}}
          </span>
        </button>
      </div>
      <div class="mt-300 mb-300 ml-800 flex flex-col gap-700">
        <div class="loading-pulse loading-pulse--col-3"></div>
        <div class="loading-pulse loading-pulse--col-3"></div>
        <div class="loading-pulse loading-pulse--col-3"></div>
      </div>
    </div>
  {{/if}}
</template> satisfies TOC<MarketCustomReportingSidebarLoadingStateSignature>;

export default MarketCustomReportingSidebarLoadingState;
